<tui-select
    tuiTextfieldSize="m"
    tuiDropdownAlign="left"
    tuiDropdownLimitWidth="min"
    class="t-select tui-group__auto-width-item"
    [tuiTextfieldLabelOutside]="true"
    [(ngModel)]="mode"
>
    <tui-data-list
        *tuiDataList
        size="s"
    >
        <button
            *ngFor="let item of modes"
            tuiOption
            [value]="item"
        >
            {{ item }}
        </button>
    </tui-data-list>
</tui-select>
<tui-primitive-textfield
    *ngIf="isHex; else rgb"
    tuiValueAccessor
    tuiTextfieldSize="m"
    [maskito]="hexMask"
    [tuiTextfieldLabelOutside]="true"
    [value]="hex"
    (valueChange)="onHexChange($event)"
></tui-primitive-textfield>
<ng-template #rgb>
    <tui-input-count
        tuiTextfieldSize="m"
        [tuiTextfieldLabelOutside]="true"
        [hideButtons]="true"
        [max]="255"
        [ngModel]="color[0]"
        (ngModelChange)="onRgbChange($event, color[1], color[2], color[3])"
    ></tui-input-count>
    <tui-input-count
        tuiTextfieldSize="m"
        [tuiTextfieldLabelOutside]="true"
        [hideButtons]="true"
        [max]="255"
        [ngModel]="color[1]"
        (ngModelChange)="onRgbChange(color[0], $event, color[2], color[3])"
    ></tui-input-count>
    <tui-input-count
        tuiTextfieldSize="m"
        [tuiTextfieldLabelOutside]="true"
        [hideButtons]="true"
        [max]="255"
        [ngModel]="color[2]"
        (ngModelChange)="onRgbChange(color[0], color[1], $event, color[3])"
    ></tui-input-count>
</ng-template>
<tui-input-count
    tuiTextfieldPostfix="%"
    tuiTextfieldSize="m"
    class="t-opacity tui-group__auto-width-item"
    [tuiTextfieldLabelOutside]="true"
    [hideButtons]="true"
    [max]="100"
    [ngModel]="opacity"
    (ngModelChange)="onRgbChange(color[0], color[1], color[2], $event / 100)"
></tui-input-count>
